import React from 'react';

const ContactPage = () => {
  return <h1>ContactPage</h1>;
};

export default ContactPage;
